<template>
  <div></div>
</template>

<script>
import HttpRequest from "@/util/HttpRequest";
import VueCookie from "vue-cookie";

export default {
  name: "Sso.vue",
  data() {
    return {

    };
  },
  computed: {
    ssoId () {
      return this.$route.query.ssoId;
    },
    redirectTo () {
      return this.$route.query.redirect_to;
    }
  },
  created() {
    this.ssoLogin();
  },
  methods: {
    ssoLogin() {
      HttpRequest.get("/api/auth/login/sso", {
        params: {
          ssoId: this.ssoId,
        },
      }).then(async (res) => {
        const token = res.token;
        const username = res.user.username

        VueCookie.set("token", token)
        localStorage.setItem("login_username", username);

        // localStorage에 보관되어 있는 키들을 가져온다
        const keys = Object.keys(localStorage);
        // _boardIds 로 끝나는 키들을 찾아서 삭제한다.
        keys.forEach((key) => {
          if (key.endsWith("_boardIds")) {
            localStorage.removeItem(key);
          }
        });
        localStorage.removeItem("/api/auth/me");
        localStorage.removeItem("/api/v1/member/all");
        localStorage.removeItem("sub_company");

        // 사용자의 프로젝트 참여 현황을 조회하기 위해서, 사용자 정보를 조회한다
        await this.$store.dispatch("member/LOAD_MEMBER_DETAIL", {project_id: -1 /* 강제로 서버에서 불러오도록 한다 */})
        const memberInfo = this.$store.state.member.memberInfo;

        // 로그인 후 이동할 페이지가 있으면 해당 페이지로 이동시킨다
        if (this.redirectTo) {
          await this.$router.push(this.redirectTo);
        }

        // 로그인 후 이동할 페이지가 없으면, 사용자가 참여한 프로젝트가 1개인 경우 해당 프로젝트 페이지로 이동시키고, 그렇지 않으면 홈페이지로 이동시킨다
        else {
          const toFullPath = VueCookie.get("LOGIN_TO_FULLPATH");
          if (toFullPath) {
            this.$router.replace(toFullPath).then((/*value*/) => {
              VueCookie.delete("LOGIN_TO_FULLPATH"); // 로그인 후 이동할 페이지 삭제
              this.$router.go(0);
            });
          } else {
            // 참여 프로젝트의 개수가 1개일 경우, 해당 프로젝트 페이지로 바로 이동시킨다
            const projects = memberInfo.projects || [];
            if (memberInfo.projects.length === 1) {
              this.$router.replace(`/project/${projects[0].id}/home`).then((/*value*/) => {
                this.$router.go(0);
              });
            } else {
              this.$router.replace("/home").then((/*value*/) => {
                this.$router.go(0);
              });
            }
          }
        }


      }).catch((err) => {
        alert("로그인 정보가 만료되었거나, 올바른 정보가 아닙니다.");
        window.history.back();
      });
    },
  },
}
</script>

<style scoped>

</style>
